import router from '../router'

let timeout = null // 创建一个标记用来存放定时器的返回值
let canRun = true
import dayjs from 'dayjs'
import OSS from 'ali-oss'
import Api from '../api/apis/public'
let clientInstance = ''

const getUploadToken = async () => {
  const res = await Api.getUploadToken()
  let data = res.data
  clientInstance = new OSS({
    // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
    region: 'oss-cn-wulanchabu',
    // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
    accessKeyId: data.AccessKeyId,
    accessKeySecret: data.AccessKeySecret,
    // 从STS服务获取的安全令牌（SecurityToken）。
    stsToken: data.SecurityToken,
    // refreshSTSToken: async () => {
    //   // 向您搭建的STS服务获取临时访问凭证。
    //   const info = await fetch('your_sts_server');
    //   return {
    //     accessKeyId: info.accessKeyId,
    //     accessKeySecret: info.accessKeySecret,
    //     stsToken: info.stsToken
    //   }
    // },
    // 刷新临时访问凭证的时间间隔，单位为毫秒。
    refreshSTSTokenInterval: 300000,
    // 填写Bucket名称。
    bucket: 'sponlax',
  })
}
const removeUploadIdFromUrl=(url)=> {
  // 使用正则表达式匹配 ?uploadId= 后面的所有内容，包括 ?uploadId= 本身
  // 注意这里使用了非贪婪匹配（*?）来确保只匹配第一个 ?uploadId= 后面的内容
  // 如果你的 URL 中可能有多个 ?uploadId=，并且你只想移除第一个，那么这个正则表达式是合适的
  // 如果你想要移除所有，那么可能需要使用其他方法或更复杂的正则表达式
  const regex = /\?uploadId=.*$/
  // 使用 replace 方法替换匹配到的部分为空字符串
  return url.replace(regex, '')
}
// 随机数6位
const mathNum = () => {
  var num = ''
  for (var i = 0; i < 6; i++) {
    num += Math.floor(Math.random() * 10)
  }
  return num
}
export default {
  toCommodityDetails: (data, isBlank) => {
     let url = `/productDetails?goods_id=${data.goods_id}&shop_type=${data.shop_type}`
    if (isBlank) {
      window.open(url, '_blank');
    } else {
      router.push({
        path: '/productDetails',
        query: {
          goods_id: data.goods_id,
          shop_type: data.shop_type,
        },
      })
    }
  },
  toPage: (url, isBlank) => {      
    if (isBlank) {
        window.open(url, '_blank');
    } else {
      location.href = url
    }
    },
  routerToPage: (url, isBlank) => {
    return router.push(url)
  },
  unique: (arr) => {
    //数组去重
    return Array.from(new Set(arr))
  },
  //去除一个数组中与另一个数组中的值相同的元素
  quChu: (a, b) => {
    //数组去重
    let c = []
    for (let i of a) {
      if (b.indexOf(i) === -1) {
        c.push(i)
      }
    }
    return c
  },
  //   将数组转换为onum个一组
  changeArr: (oarr, onum) => {
    const arr = oarr || []
    const len = arr.length
    let result = []
    const sliceNum = onum // 这个值代表几个一组

    for (let i = 0; i < len / sliceNum; i++) {
      result.push(arr.slice(i * sliceNum, (i + 1) * sliceNum))
    }
    // 补足不足onum个的最后一个数组
    // for(let j = 0; j < (sliceNum - len % sliceNum); j++) {
    //     result[result.length - 1].push({})
    // }

    return result
  },

  /**
   * 函数防抖
   * 触发事件后在n秒后执行，如果n秒内又触发事件，则重新计算时间
   */
  debounce(func, wait = 500, immediate = false) {
    // 清除定时器
    if (timeout !== null) clearTimeout(timeout)
    // 立即执行，此类情况一般用不到
    if (immediate) {
      var callNow = !timeout
      timeout = setTimeout(function() {
        timeout = null
      }, wait)
      if (callNow) typeof func === 'function' && func()
    } else {
      // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
      timeout = setTimeout(function() {
        typeof func === 'function' && func()
      }, wait)
    }
  },

  /**
   * 函数节流
   * 触发事件立即执行，但在n秒内连续触发则不执行
   */
  throttle(func, wait = 500, immediate = true) {
    let timer, flag
    if (immediate) {
      if (!flag) {
        flag = true
        // 如果是立即执行，则在wait毫秒内开始时执行
        typeof func === 'function' && func()
        timer = setTimeout(() => {
          flag = false
        }, wait)
      }
    } else {
      if (!flag) {
        flag = true
        // 如果是非立即执行，则在wait毫秒内的结束处执行
        timer = setTimeout(() => {
          flag = false
          typeof func === 'function' && func()
        }, wait)
      }
    }
  },
  //   加密字符串
  toCode(str) {
    //加密字符串
    //定义密钥，36个字母和数字
    var key = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    var l = key.length //获取密钥的长度
    var a = key.split('') //把密钥字符串转换为字符数组
    var s = '',
      b,
      b1,
      b2,
      b3 //定义临时变量
    for (var i = 0; i < str.length; i++) {
      //遍历字符串
      b = str.charCodeAt(i) //逐个提取每个字符，并获取Unicode编码值
      b1 = b % l //求Unicode编码值得余数
      b = (b - b1) / l //求最大倍数
      b2 = b % l //求最大倍数的于是
      b = (b - b2) / l //求最大倍数
      b3 = b % l //求最大倍数的余数
      s += a[b3] + a[b2] + a[b1] //根据余数值映射到密钥中对应下标位置的字符
    }
    return s //返回这些映射的字符
  },
  // 解密字符串
  fromCode(str) {
    //定义密钥，36个字母和数字
    var key = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    var l = key.length //获取密钥的长度
    var b,
      b1,
      b2,
      b3,
      d = 0,
      s //定义临时变量
    s = new Array(Math.floor(str.length / 3)) //计算加密字符串包含的字符数，并定义数组
    b = s.length //获取数组的长度
    for (var i = 0; i < b; i++) {
      //以数组的长度循环次数，遍历加密字符串
      b1 = key.indexOf(str.charAt(d)) //截取周期内第一个字符串，计算在密钥中的下标值
      d++
      b2 = key.indexOf(str.charAt(d)) //截取周期内第二个字符串，计算在密钥中的下标值
      d++
      b3 = key.indexOf(str.charAt(d)) //截取周期内第三个字符串，计算在密钥中的下标值
      d++
      s[i] = b1 * l * l + b2 * l + b3 //利用下标值，反推被加密字符的Unicode编码值
    }
    b = eval('String.fromCharCode(' + s.join(',') + ')') //用fromCharCode()算出字符串
    return b //返回被解密的字符串
  },
  // 将数字四舍五入，传入参数:数字，小数位数
  roundNumber(Num, wei) {
    return Number(Num.toFixed(wei))
  },
  // 将数字向上取整n位
  ceil(num, byte) {
    if (!byte) {
      var byte = 2
    }
    // let n = 10 ** byte
    return Number(num).toFixed(2)
  },
  // 跳转到指定元素，传入元素的ref或者id，如this.$refs.hfdh
  maoDian(element, orderHeight) {
    let toTop = element.offsetTop
    if (orderHeight) {
      toTop = element.offsetTop + orderHeight
    }
    window.scrollTo(0, toTop)
  },
  to_link(txtContent) {
    let check_www = 'w{3}' + '[^\\s]*'
    let check_http = '(https|http|ftp|rtsp|mms)://' + '[^\\s]*'
    let strRegex = check_www + '|' + check_http
    let httpReg = new RegExp(strRegex, 'gi')
    return txtContent.replace(httpReg, function(httpText) {
      return httpText.search('http') < 0 && httpText.search('HTTP') < 0
    })
  },
  downloadIamge(imgsrc, name) {
    // 下载图片地址和图片名
    var image = new Image()
    // 解决跨域 Canvas 污染问题
    image.setAttribute('crossOrigin', 'anonymous')
    image.onload = function() {
      var canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      var context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, image.width, image.height)
      var url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
      var a = document.createElement('a') // 生成一个a元素
      var event = new MouseEvent('click') // 创建一个单击事件
      a.download = name || 'photo' // 设置图片名称
      a.href = url // 将生成的URL设置为a.href属性
      a.dispatchEvent(event) // 触发a的单击事件
    }
    image.src = imgsrc
  },
  // 把价格两位小数后的文字缩小
  twoSmall(value, fontSize) {
    if (value % 1 > 0) {
      let arr = value.toString().split(',')
      return '<font>' + arr[0] + ".</font><font style='font-size:'" + fontSize
        ? fontSize
        : '20' + "'px'>" + arr[1] + '</font>'
    }
    return value
  },
  // 卢布价格
  EURNumSegmentation(Num) {
    let num = String(Num).replace(/\./g, '.')
    if (num != 'undefined') {
      return Number(num).toFixed(2)
    } else {
      return 0
    }
  },
  // 价格千分位逗号隔开
  EURNum(Num) {
    let re = /\d(?=(?:\d{3})+\b)/g
    // let num = String(Num).replace(/./, ',')
    let num = String(Num).replace(/\./g, ',')
    num = String(num).replace(re, '$&,')
    return num
  },
  huilvqianf(Num) {
    // let num = (String(Num).replace(/\./g, ','));
    return Num
  },
  roundFixed(num) {
    //修改js四舍五入
    if (Number.isFinite(num)) {
      //判断是否为数字
      //使用 ES6 中新增的数字方法 toLocaleString() 中提供的 maximumFractionDigits 参数，如：
      let result = num.toLocaleString(undefined, { maximumFractionDigits: 2 })
      //小数部分位数不够时补零
      let float_part = result.split('.')[1]
      //如果小数部分无值，直接补零
      if (!float_part) {
        let zero_str = (Math.pow(10, 2) + '').split('1')[1] //要补的零
        result = result + '.' + zero_str
        return result
      }
      //如果小数位数不够，补缺少的零
      if (float_part.length < 2) {
        let float_part_length = float_part.length
        let zero_str = (Math.pow(10, 2 - float_part_length) + '').split('1')[1] //要补的零
        result = result + zero_str //小数部分已有小数点，不需再拼小数点
        return result
      }
      return result //正常的情况，直接返回
    } else {
      //不是数字
      return ''
    }
  },
  // 人民币价格千分位
  RMBNumSegmentation(Num) {
    // let re = /\d(?=(?:\d{3})+\b)/g;
    // let num = (String(Num).replace(/\./g, ','));
    // num = String(num).replace(re, "$&.")
    if (Num) {
      let fixedNum = Number(Num).toFixed(2);
      return Number(Num).toFixed(2)
    } else {
      return 0
    }
  },

  // 将每个单词首字母转换成大写
  trunUpperCase(v) {
    return v
      .trim()
      .toLowerCase()
      .replace(/( |^)[a-z]/g, (L) => L.toUpperCase())
  },
  // 判断是否是数组
  isArray(arr) {
    return Object.prototype.toString.call(arr) === '[object Array]'
  },
  // 深度克隆
  deepClone(obj) {
    // 对常见的“非”值，直接返回原来值
    if ([null, undefined, NaN, false].includes(obj)) return obj
    if (typeof obj !== 'object' && typeof obj !== 'function') {
      //原始类型直接返回
      return obj
    }
    var o = this.isArray(obj) ? [] : {}
    for (let i in obj) {
      if (obj.hasOwnProperty(i)) {
        o[i] = typeof obj[i] === 'object' ? this.deepClone(obj[i]) : obj[i]
      }
    }
    return o
  },

  async startUpload(uploadtype, rawFile, uploadProgressCallback) {
    await getUploadToken()

    const year = dayjs().year()
    const month = dayjs().format('MM')
    // 假设mathNum()是一个生成随机数的函数，这里需要确保它在外部定义或作为参数传入
    let name = (rawFile.uid ? rawFile.uid  : rawFile.lastModified)    + mathNum()
    // 构建目标路径（如果需要的话，可以在uploadConfig中传入自定义的路径）
    const targetPath = '/dest/' + year + month + '/' + name + '/' + rawFile.name
    if (uploadtype == 'put') {
      return new Promise((resolve, reject) => {
        clientInstance
          .put(targetPath, rawFile)
          .then(function(imgOBJ) {
            // 通知调用者上传成功
            resolve(imgOBJ)
          })
          .catch(function(err) {
            // 通知调用者上传失败
            reject(err)
          })
      })
    } else {
      return new Promise((resolve, reject) => {
        clientInstance
          .multipartUpload(targetPath, rawFile, {
            progress: function(percentage) {
              let percentagenum = Math.round(percentage * 100)
              uploadProgressCallback(rawFile, percentagenum)
            },
            partSize: 10 * 1024 * 1024, // 指定分片大小
          })
          .then(function(imgOBJ) {
            // 通知调用者上传成功

            if (imgOBJ.res.requestUrls[0]) {
              imgOBJ.res.requestUrls[0] = removeUploadIdFromUrl(
                imgOBJ.res.requestUrls[0]
              )
            }
            console.log(imgOBJ.res.requestUrls[0])
            resolve(imgOBJ)
          })
          .catch(function(err) {
            // 通知调用者上传失败
            reject(err)
          })
      })
    }
  },
}
